import React, { useEffect } from "react";
import Header from "../components/Header";
import Admin from "../components/Admin";

const AdminPage: React.FC = () => {
  useEffect(() => {
    document.title = "F&M - Admin";
  }, []);
  return (
    <>
      <Header onProfileClick={() => {}} hideAdminLink />
      <main className="admin-page-container">
        <Admin />
      </main>
    </>
  );
};

export default AdminPage;
